import React from 'react';
import { offer } from '../data/offer';
export function Footer() {
  return <footer className="border-t border-acad-line bg-acad-ink px-4 py-10 text-center" data-id="element-91" data-mp="3gf942tsw627w">
      <p className="font-display text-2xl font-semibold text-white" data-id="element-92" data-mp="3gh3s4gzgmag7">
        {offer.name}
      </p>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-white/70" data-id="element-93" data-mp="32m1ch24t96q7">
        Stop planning every class from zero. Start teaching with a system.
      </p>
      <p className="mt-6 text-xs text-white/50" data-id="element-94" data-mp="3ugbpd4c2b8hr">
        © 2026 {offer.name} — All rights reserved.
      </p>
    </footer>;
}